import { initializeApp } from 'firebase/app';
import { getAuth, onAuthStateChanged } from 'firebase/auth';  // Pour l'authentification
import { getFirestore } from 'firebase/firestore';  // Pour Firestore
import { getStorage } from 'firebase/storage';  // Pour Firebase Storage

// Votre configuration Firebase (remplacez avec vos propres clés)
const firebaseConfig = {
  apiKey: "AIzaSyDIAThJDm0WFt1sLemISxRdmNquR3nBThg",
  authDomain: "aladinn-edu.firebaseapp.com",
  databaseURL: "https://aladinn-edu-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "aladinn-edu",
  storageBucket: "aladinn-edu.appspot.com",
  messagingSenderId: "475377366679",
  appId: "1:475377366679:web:63202426ea12b5e023dbd2",
  measurementId: "G-PS9LBTNYZ5"
};

// Initialiser Firebase
const app = initializeApp(firebaseConfig);

// Initialiser Firestore, Storage et Authentification
const db = getFirestore(app);  // Initialiser Firestore
const storage = getStorage(app);  // Initialiser Firebase Storage
const auth = getAuth(app);  // Pour l'authentification

// Fonction pour récupérer le token d'ID Firebase de l'utilisateur actuel
const getFirebaseToken = async () => {
  const user = auth.currentUser;  // Obtenir l'utilisateur actuel
  if (user) {
    try {
      const token = await user.getIdToken();  // Récupérer le token d'ID
      return token;  // Retourner le token
    } catch (error) {
      console.error('Erreur lors de la récupération du token Firebase:', error);
      return null;  // Retourner null si erreur
    }
  } else {
    console.error('Aucun utilisateur connecté');
    return null;  // Retourner null si l'utilisateur n'est pas connecté
  }
};

// Exporter les modules nécessaires pour utilisation dans d'autres parties de l'application
export { auth, db, storage, getFirebaseToken };  // Exporter getFirebaseToken également
